import React from "react";

export default function CustomBorderButton({
                                               onClick,
                                               state = "idle", // current button state
                                               size = "small", // small, medium, large
                                               captions = {
                                                 idle: "Request",
                                                 queued: "In queue...",
                                                 processing: "Exporting...",
                                                 done: "Export ready!",
                                                 error: "Failed — retry?",
                                               },
                                               disabledStates = ["queued", "processing"],
                                               className = "",
                                             }) {
  const isDisabled = disabledStates.includes(state);

  const stateStyles = {
    idle: "border-brand-200 text-brand-600 dark:border-brand-700 dark:text-brand-300 hover:bg-brand-50 dark:hover:bg-brand-900/30",
    queued: "border-yellow-200 text-yellow-700 dark:border-yellow-700 dark:text-yellow-300 cursor-wait",
    processing: "border-gray-200 text-gray-700 dark:border-gray-700 dark:text-gray-300 cursor-wait",
    done: "border-green-200 text-green-700 dark:border-green-700 dark:text-green-300",
    error: "border-red-200 text-red-700 dark:border-red-700 dark:text-red-300",
  };

  const sizeStyles = {
    small: "text-xs px-2 py-0.5",
    medium: "text-sm px-3 py-1.5",
    large: "text-base px-4 py-2",
  };

  return (
    <button
      type="button"
      onClick={!isDisabled ? onClick : undefined}
      disabled={isDisabled}
      aria-pressed={isDisabled}
      className={`inline-flex items-center rounded-md border focus:outline-none transition-all duration-200 ${sizeStyles[size]} ${stateStyles[state]} ${className}`}
    >
      {captions[state] || captions.idle}
    </button>
  );
}